import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { updateField } from '../actions'

const Tips = ({shift, sid}) => {
    const dispatch = useDispatch()
    const [sushiTip, setSushiTip] = useState(shift.SushiTip)
    const [barTip, setBarTip] = useState(shift.BarTip)
    const [expoTip, setExpoTip] = useState(shift.ExpoTip)
    const [hostTip, setHostTip] = useState(shift.HostTip)
    const [busserTip, setBusserTip] = useState(shift.BusserTip)
    const [notes, setNotes] = useState(shift.Notes)
    const [finalTipOut, setFinalTipOut] = useState(shift.FinalTipOut)
    useEffect(() => {
        setSushiTip(shift.SushiTip)
        setBarTip(shift.BarTip)
        setExpoTip(shift.ExpoTip)
        setHostTip(shift.HostTip)
        setBusserTip(shift.BusserTip)
        setFinalTipOut(shift.FinalTipOut)
        setNotes(shift.Notes)
      }, [shift]);
    return !shift.IsLunch? (
        <div>
        <span><label>Sushi Tip</label>
        <input type="text" name="hours" style={{width: '50px'}} value={sushiTip} onChange={e => setSushiTip(e.target.value)} onBlur={() => {dispatch(updateField(sid, sushiTip, 'SUSHITIP'))}}/>
    </span>
    <span><label>Bar Tip</label>
        <input type="text" name="hours" style={{width: '50px'}} value={barTip} onChange={e => setBarTip(e.target.value)} onBlur={() => {dispatch(updateField(sid, barTip, 'BARTIP'))}} />
    </span>
    <span><label>Expo Tip</label>
        <input type="text" name="hours" style={{width: '50px'}} value={expoTip}  onChange={e => setExpoTip(e.target.value)} onBlur={() => {dispatch(updateField(sid, expoTip, 'EXPOTIP'))}}  />
    </span>
    <span><label>Host Tip</label>
        <input type="text" name="hours" style={{width: '50px'}} value={hostTip} onChange={e => setHostTip(e.target.value)} onBlur={() => {dispatch(updateField(sid, hostTip, 'HOSTTIP'))}}  />
    </span>
    <span><label>Busser Tip</label>
        <input type="text" name="hours" style={{width: '50px'}} value={busserTip} onChange={e => setBusserTip(e.target.value)} onBlur={() => {dispatch(updateField(sid, busserTip, 'BUSSERTIP'))}}  />
    </span>
    <span><label>Final Tip Out: &nbsp;&nbsp;</label>
        <input type="text" name="hours" style={{width: '100px'}} value={finalTipOut} onChange={e => setFinalTipOut(e.target.value)} onBlur={() => {dispatch(updateField(sid, finalTipOut, 'FINALTIPOUT'))}}  />
        {/* {finalTipOut} */}
    </span>
    <span>&nbsp;&nbsp;&nbsp;&nbsp;
        <label>Notes:&nbsp;&nbsp;</label>
        <input type="text" name="notes" style={{width: '200px'}} value={notes} onChange={e => setNotes(e.target.value)} onBlur={() => {dispatch(updateField(sid, notes, 'NOTES'))}}  />
    </span>
    </div>
    ) : (
    <div>
        <span><label>Sushi Tip</label>
        <input type="text" name="hours" style={{width: '50px'}} value={sushiTip} onChange={e => setSushiTip(e.target.value)} onBlur={() => {dispatch(updateField(sid, sushiTip, 'SUSHITIP'))}}/>
        </span>
        <span><label>Host Tip</label>
            <input type="text" name="hours" style={{width: '50px'}} value={hostTip} onChange={e => setHostTip(e.target.value)} onBlur={() => {dispatch(updateField(sid, hostTip, 'HOSTTIP'))}}  />
        </span>
        <span><label>Expo Tip</label>
            <input type="text" name="hours" style={{width: '50px'}} value={expoTip} onChange={e => setExpoTip(e.target.value)} onBlur={() => {dispatch(updateField(sid, expoTip, 'EXPOTIP'))}}  />
        </span>
        <span><label>Final Tip Out: &nbsp;&nbsp;</label>
            <input type="text" name="hours" style={{width: '100px'}} value={finalTipOut} onChange={e => setFinalTipOut(e.target.value)} onBlur={() => {dispatch(updateField(sid, finalTipOut, 'FINALTIPOUT'))}}  />
            {/* {finalTipOut} */}
        </span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;
            <label>Notes:&nbsp;&nbsp;</label>
            <input type="text" name="notes" style={{width: '200px'}} value={notes} onChange={e => setNotes(e.target.value)} onBlur={() => {dispatch(updateField(sid, notes, 'NOTES'))}}  />
        </span>
    </div> 
    )
}

export default Tips